const colors = {
  primary: 'black',
  red: 'red', // or #EF3829
  white: 'white',
  gray: 'gray',
  orange: '#FF8200',
  'teal-blue': 'var(--teal-blue)'
};

export default {
  props: {
    color: {
      type: String,
      default: 'currentColor'
    },
    size: {
      type: [String, Number],
      default: 16
    },
    scale: {
      type: [String, Number],
      default: 1
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    calcColor() {
      return colors[this.color] || this.color;
    },
    calcHeight() {
      return `${this.size * this.scale}`;
    },
    calcWidth() {
      return `${this.size * this.scale}`;
    }
  }
};
